export default "__VITE_ASSET__DpBptdAo__"